import { HeroTextWrapperProps } from 'sly/agentsPage/components/AgentsHeader/HeroTextWrapper/HeroTextWrapper.types';

export default function HeroTextWrapper({ children }: HeroTextWrapperProps) {
  return (
    <div
      className='hero-text-wrapper'
      data-tp-id='gen-div-8cb47c1d-e901-4eb3-95d2-dd5bb1cfcd98'
    >
      {children}
    </div>
  );
}
